// Splash2.js
import React from "react";
import fifty from "./30.png";
export default function Splash2() {
  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center vh-100 text-white"
      style={{
        backgroundImage: `url(${fifty})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        position: "relative",
      }}
    >
      {/* Bottom progress bar */}
      <div
        style={{
          position: "absolute",
          bottom: "28px",
          left: "50%",
          transform: "translateX(-50%)",
          width: "min(86vw, 420px)",
          height: "8px",
          borderRadius: "999px",
          background: "rgba(255, 255, 255, 0.25)",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            height: "100%",
            width: "35%",
            borderRadius: "999px",
            background: "#ffffff",
            animation: "progressSlide 1.6s ease-in-out infinite",
          }}
        />
      </div>

      {/* Keyframes */}
      <style>{`
        @keyframes progressSlide {
          0% {
            transform: translateX(-100%);
          }
          50% {
            transform: translateX(110%);
          }
          100% {
            transform: translateX(-100%);
          }
        }
      `}</style>
    </div>
  );
}
